import type { TaskRow } from './types';

import { tx } from '../../../lib/adminI18n';
// 担当者の表示（★=代表者 / 未割当はオレンジ）
export default function AssigneeCell({ t }: { t: TaskRow }) {
  const list = t.assignees || [];
  if (!list.length) return <span className="cln-unassigned">{tx('clnA.0')}</span>;
  return (
    <span className="cln-assignees-inline">
      {list.map((a) => (
        <span key={a.id} className={`cln-assignee ${a.is_active ? '' : 'inactive'}`}>
          {a.is_lead ? '★' : ''}{a.name}
        </span>
      ))}
    </span>
  );
}
